import { useCallback, useState } from 'react'
import { Form, Input, Button, Row, Col, Select, InputNumber } from 'antd'
import { UpOutlined, DownOutlined } from '@ant-design/icons'
import styles from './styles.module.scss'
import { removeUndefinedValues, removeVietnameseTones } from '../../config-func'
import { labelOptions } from '../../configData'
import { debounce } from 'lodash'
import { current_status, status } from './configs'
const { Option } = Select

const SearchForm = ({ form, fetchData = () => {}, pagination,listProject, listCities, listDistricts, listTowns, onChangeCity, onChangeDistrict, onChangePostType, typeRealEstate, ProductType, setFilters, isFullscreen = false }) => {
  // const [form] = Form.useForm()
  const [expanded, setExpanded] = useState(false)


  const handleSearch = useCallback(
    debounce((allValues) => {
      const { ...data } = allValues
      const params = removeUndefinedValues({
        ...data,
        currentPage: 1,
        page: pagination.current,
        pageSize: pagination.pageSize
      })
      setFilters(params)
      fetchData(params)
    }, 500),
    [pagination.current, pagination.pageSize]
  )

  const handleReset = debounce(() => {
    // setFilters({currentPage: 1,
    // pageSize: 10})
    form.resetFields()
    setFilters({currentPage: 1,page: 1, pageSize: 10})
    handleSearch({currentPage: 1,page: 1, pageSize: 10})
  }, 300)

  const fields = [
    { label: 'Dự án', name: 'project', type: 'select' , typeValue: 'label' ,arr: listProject, hidden: !expanded },
    { label: 'Loại BDS', name: 'realstate', type: 'select', typeValue: 'label' , arr: ProductType, onChange: onChangePostType, hidden: !expanded },
    {
      label: 'Loại hình BDS',
      name: 'type_real_estate',
      type: 'select',
      typeValue: 'label',
      arr: typeRealEstate,
      // onChange: onChangePostType,
      hidden: !expanded
    },
    // { label: 'Đường phố', name: 'street' },
    { label: 'Khu vực', name: 'area', type: 'select', arr: listCities, onChange: onChangeCity },
    { label: 'Quận/Huyện', name: 'district', type: 'select',arr: listDistricts, onChange: onChangeDistrict },
    { label: 'Phường/Xã', name: 'tower', type: 'select',arr: listTowns },
    { label: 'Loại dữ liệu', name: 'type', type: 'select',arr: [
      { label: 'NET', value: 'NET' },
      { label: 'DL', value: 'DL' }
    ] },
    { label: 'Quan hệ', name: 'relationship' },
    { label: 'Thành viên Căn Hộ', name: 'member' },
    { label: 'Điện thoại', name: 'phone' },
    { label: 'Mã căn hộ', name: 'apartment_code' },
    { label: 'Tòa', name: 'building' },
    { label: 'Tầng', name: 'floor' },
    { label: 'Căn', name: 'room' },
    // { label: 'Thông tin', name: 'info' },
    { label: 'Nhu cầu', name: 'status', type: 'select',arr: status },
    { label: 'Tình trạng', name: 'current_status', type: 'select',arr: current_status },
    // { label: 'Nội thất', name: 'funiture', type: 'select',arr: [{value: 'Full', label: 'Full'}, {value: 'Cơ bản', label: 'Cơ bản'} ,{value: 'Nguyên bản', label: 'Nguyên bản'}, 
    //   {value: 'Thô', label: 'Thô'}
    // ] },
    { label: 'Note', name: 'lastest_note' },
    { label: 'Mã tin', name: 'post_id' },
    { label: 'CSKH (Tên)', name: 'user_support' },
    // { label: 'Số lần gọi', name: 'number_call' },
    // {
    //   label: 'Tên Sàn',
    //   name: 'department_id',
    //   type: 'select',
    //   arr: listDepartment,
    //   onChange: onChangeDepartment
    // },

    // {
    //   label: 'Loại BĐS',
    //   name: 'post_type',
    //   type: 'select',
    //   arr: ProductType,
    //   onChange: onChangePostType
    // },
    // {
    //   label: 'Loại hình BĐS',
    //   name: 'type_real_estate',
    //   type: 'select',
    //   arr: listTypeRealEstate
    // },
  
    // {
    //   label: 'Tỉnh/Thành phố',
    //   name: 'city_code',
    //   type: 'select',
    //   arr: cities,
    //   onChange: onChangeCity
    // },
    // {
    //   label: 'Quận/Huyện',
    //   name: 'district_code',
    //   type: 'select',
    //   arr: districts,
    //   onChange: onChangeDistrict
    // },
  ]

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSearch}
      // labelCol={{ span: 8 }}
      // labelAlign="right"
      style={{ marginTop: 10 }}
      onValuesChange={(value, allValues) => {
        if (value.city_code) {
          form.setFieldsValue({
            district_code: null,
            town_code: null
          })
        }
        if (value.district_code) {
          form.setFieldsValue({
            town_code: null
          })
        }
      }}
    >
      {expanded ? (
        <>
          <div className={styles.formAddFilter}>
            {fields.map((field, index) => (
              <Form.Item
                // labelCol={{ span: 8 }}
                label={field.label}
                name={field.name}
                style={{
                  marginBottom: 8,
                  display: field.hidden == true ? 'none' : 'block'
                }}
                className={styles.formItemFilter}
              >
                {
                  field.type === 'select' ? (
                    <Select
                      style={{ width: '100%' }}
                      placeholder={`Chọn ${field.label}`}
                      onChange={field.onChange}
                      showSearch={true}
                      allowClear={true}
                      getPopupContainer={() => isFullscreen ? document.body : undefined}
                      dropdownStyle={{
                        zIndex: isFullscreen ? 10001 : undefined,
                        position: isFullscreen ? 'fixed' : undefined
                      }}
                      dropdownClassName={isFullscreen ? 'fullscreen-select-dropdown' : undefined}
                      filterOption={(input, option) => {
                        const inputValue =
                          removeVietnameseTones(input).toLowerCase()
                        const optionValue = removeVietnameseTones(
                          option?.children || ''
                        ).toLowerCase()
                        return optionValue.includes(inputValue)
                      }}
                    >
                      {field.arr && field.arr.length > 0 ? (
                        field.arr.map((item, idx) => (
                          <Option key={idx} value={field.typeValue ? item.label : item.value}>
                            {item.label}
                          </Option>
                        ))
                      ) : (
                        <>
                          {/* <Option value="option1">Option 1</Option>
                        <Option value="option2">Option 2</Option> */}
                        </>
                      )}
                    </Select>
                  ) : field.name == 'acreage' ||
                    field.name == 'area_outside' ? (
                    <InputNumber
                      onBlur={(e) => {
                        const value = parseFloat(e.target.value?.trim())
                        form.setFields([
                          {
                            name: field.name,
                            value: isNaN(value) ? 0 : value
                          }
                        ])
                      }}
                      className={styles.InputNumber}
                      formatter={(value) =>
                        value ? value.replace(/[^0-9.]/g, '') : ''
                      }
                      parser={(value) => value.replace(/[^0-9.]/g, '.')}
                      placeholder="Nhập diện tích"
                    />
                  ) : (
                    <Input
                      placeholder={`Nhập ${field.label.toLowerCase()}`}
                      onBlur={(e) => {
                        form.setFields([
                          {
                            name: field.name,
                            value: e.target.value?.trim()
                          }
                        ])
                      }}
                    />
                  )
                  // <Input placeholder={`Nhập ${field.label}`} />
                }
              </Form.Item>
            ))}
            <Form.Item
              label=""
              name=""
              className={styles.formItemFilter}
            ></Form.Item>
            <div
              className={styles.formItemFilter}
              style={{ textAlign: 'right', marginBottom: 8 }}
            >
              <Button onClick={handleReset}>Đặt lại</Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{ margin: '0 8px' }}
              >
                Tìm kiếm
              </Button>
              <span
                className="d-flex"
                style={{ color: '#08c', cursor: 'pointer' }}
                onClick={() => setExpanded(!expanded)}
              >
                Thu nhỏ{' '}
                <UpOutlined style={{ fontSize: '14px', color: '#08c' }} />
              </span>
            </div>
          </div>
        </>
      ) : (
        <div
          style={{
            // display: 'flex',
            // margin: '-0 8px',
            // justifyContent: 'space-between'
            display: 'flex',
            // margin: '-0 8px',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            // gap: 16,
            alignItems: 'center'
          }}
        >
          <Form.Item label="Dự án" name="project" className={styles.formItemFilter}>
            <Select
              placeholder="Chọn Dự án"
              showSearch={true}
              allowClear={true}
              getPopupContainer={() => isFullscreen ? document.body : undefined}
              dropdownStyle={{
                zIndex: isFullscreen ? 10001 : undefined,
                position: isFullscreen ? 'fixed' : undefined
              }}
              dropdownClassName={isFullscreen ? 'fullscreen-select-dropdown' : undefined}
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(option?.children || '').toLowerCase()
                return optionValue.includes(inputValue)
              }}
            >
              {listProject.map((item) => (
                <Option key={item.value} value={item.label}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Loại BDS"
            name="realstate"
            className={styles.formItemFilter}
          >
           <Select
              placeholder="Chọn Loại BDS"
              showSearch={true}
              allowClear={true}
              onChange={onChangePostType}
              getPopupContainer={() => isFullscreen ? document.body : undefined}
              dropdownStyle={{
                zIndex: isFullscreen ? 10001 : undefined,
                position: isFullscreen ? 'fixed' : undefined
              }}
              dropdownClassName={isFullscreen ? 'fullscreen-select-dropdown' : undefined}
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(option?.children || '').toLowerCase()
                return optionValue.includes(inputValue)
              }}
            >
              {ProductType.map((item) => (
                <Option key={item.value} value={item.label}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Loại hình BDS"
            name="type_real_estate"
            className={styles.formItemFilter}
          >
            <Select
              placeholder="Chọn Loại hình BDS"
              showSearch={true}
              allowClear={true}
              getPopupContainer={() => isFullscreen ? document.body : undefined}
              dropdownStyle={{
                zIndex: isFullscreen ? 10001 : undefined,
                position: isFullscreen ? 'fixed' : undefined
              }}
              dropdownClassName={isFullscreen ? 'fullscreen-select-dropdown' : undefined}
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase()
                const optionValue = removeVietnameseTones(option?.children || '').toLowerCase()
                return optionValue.includes(inputValue)
              }}
            >
              {typeRealEstate.map((item) => (
                <Option key={item.value} value={item.label}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <div
            className={styles.formItemFilter}
            style={{ textAlign: 'right', marginTop: 6 }}
          >
            <Button onClick={handleReset}>Đặt lại</Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{ margin: '0 8px' }}
            >
              Tìm kiếm
            </Button>
            <span
              className="d-flex"
              style={{ color: '#08c', cursor: 'pointer' }}
              onClick={() => setExpanded(!expanded)}
            >
              Mở rộng{' '}
              <DownOutlined style={{ fontSize: '14px', color: '#08c' }} />
            </span>
          </div>
          {/* )} */}
        </div>
      )}
    </Form>
  )
}

export default SearchForm
